export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + sizes[i];
};

export const fileSizeInMegaBytes = bytes => {
  return bytes / (1024 * 1024);
};

export const checkFileSizeLimit = (file, maximumUploadLimit) => {
  const fileSize = file?.file?.size || file?.size;
  const fileSizeInMB = fileSizeInMegaBytes(fileSize);
  return fileSizeInMB <= maximumUploadLimit;
};

// d99d DirectUpload only reports `Error storing "<file>". Status: <code>`, map the server's rejection codes to a message
const DIRECT_UPLOAD_ERRORS = {
  413: 'CONVERSATION.UPLOAD_ERROR.TOO_LARGE',
  415: 'CONVERSATION.UPLOAD_ERROR.TYPE_NOT_SUPPORTED',
  422: 'CONVERSATION.UPLOAD_ERROR.UNSAFE',
};

export const directUploadErrorKey = error => {
  const status = String(error).match(/^Error storing .*Status: (\d+)$/)?.[1];
  return DIRECT_UPLOAD_ERRORS[status] || null;
};
